import { render, staticRenderFns } from "./NewsStory.vue?vue&type=template&id=aea2c4da&scoped=true&"
import script from "./NewsStory.vue?vue&type=script&lang=js&"
export * from "./NewsStory.vue?vue&type=script&lang=js&"
import style0 from "./NewsStory.vue?vue&type=style&index=0&id=aea2c4da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea2c4da",
  null
  
)

export default component.exports